import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="main-footer">
        <div className="top-pattern-layer-dark"></div>

        {/* Widgets Section */}
        {/* <div className="widgets-section">
          <div className="auto-container">
            <div className="row clearfix">

              <div className="column col-xl-3 col-lg-12 col-md-12 col-sm-12">
                <div className="footer-widget about-widget">
                  <div className="logo">
                    <Link to="/">
                      <img src="logo.png" alt="AlphaBlind Logo" />
                    </Link>
                  </div>
                  <div className="text">
                    We craft modern websites, mobile apps, and digital solutions to help
                    businesses grow and succeed online.
                  </div>

                  <div className="info">
                    <ul>
                      <li>Toronto, Ontario, Canada</li>
                      <li>
                        Call us:{" "}
                        <a href="tel:416 806 6367">
                          <strong>416.806.6367</strong>
                        </a>
                      </li>
                      <li>
                        <a href="mailto:info@AlphaBlind.ca">info@AlphaBlind.ca</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="column col-xl-9 col-lg-12 col-md-12 col-sm-12">
                <div className="footer-widget links-widget">
                  <div className="widget-content">
                    <div className="row clearfix">

                      <div className="column col-lg-4 col-md-4 col-sm-12">
                        <div className="widget-title">
                          <h4>Services</h4>
                        </div>
                        <ul className="links">
                          <li><Link to="/services">Web Development</Link></li>
                          <li><Link to="/services">Mobile App Development</Link></li>
                          <li><Link to="/services">SEO & Digital Marketing</Link></li>
                          <li><Link to="/services">UI/UX Design</Link></li>
                          <li><Link to="/services">Branding Solutions</Link></li>
                        </ul>
                      </div>

                      <div className="column col-lg-4 col-md-4 col-sm-12">
                        <div className="widget-title">
                          <h4>Technologies We Use</h4>
                        </div>
                        <ul className="links">
                          <li>React / Next.js</li>
                          <li>Node.js / Express</li>
                          <li>MongoDB / MySQL</li>
                          <li>Flutter / React Native</li>
                          <li>HTML, CSS, JavaScript</li>
                        </ul>
                      </div>

                      <div className="column col-lg-4 col-md-4 col-sm-12">
                        <div className="widget-title">
                          <h4>Why Choose Us</h4>
                        </div>

                        <ul className="links">
                          <li>Expert & Experienced Team</li>
                          <li>Fast & Reliable Delivery</li>
                          <li>Modern & Scalable Solutions</li>
                          <li>Transparent Communication</li>
                          <li>Affordable Pricing</li>
                        </ul>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div> */}

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="auto-container">
            <div className="inner">
                <div className="column col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div className="footer-widget about-widget">
                  {/* <div className="logo">
                    <Link to="/">
                      <img src="logo.png" alt="AlphaBlind Logo" />
                    </Link>
                  </div>
                  <div className="text">
                    We build modern websites and digital solutions that help businesses grow.
                  </div> */}

                  <div className="info">
                    <ul>
                      <li><b>Address:</b> Suite 143, 125-720 King Street West, Toronto ON M5V 3S5</li>
                      <li>
                        <b>Call us:{" "}</b>
                        <Link to="tel:416 806 6367">
                          <strong>416 806 6367</strong>
                        </Link>
                      </li>
                      <li>
                        <b>Email: </b><Link to="mailto:info@AlphaBlind.ca">info@AlphaBlind.ca</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="copyright">
                <b>&copy; 2025 AlphaBlind. All rights reserved.</b>
              </div>
            </div>
          </div>
        </div>

      </footer>
    </>
  );
};

export default Footer;
